const CONFIG = {
    enabledCountries: ["FR", "RO"],
    enabledLanguages: ["en", "it", 'fr', 'ro'],
}

export default CONFIG;

export type CONFIG = typeof CONFIG;
